export default {
    lang: {
        name: 'Plays all-time'
    }
}